import * as React from 'react';
//import { useTheme } from '@mui/material/styles';
//import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
// import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';


const theme = createTheme({
  overrides: {
      MuiTableCell: {
          root: {  //This can be referred from Material UI API documentation. 
              padding: '0px 4px',
              // backgroundColor: "#eaeaea",
          },
      },
  },
});

const PiaCard = (props) => {
  //export default function RequestCard(title) {
  //const theme = useTheme();
  //debugger;

  // console.log(props);
  if (!props.rows) {

    return (<Title>{props.title}</Title>);
  }
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
       <Title>{props.title} </Title>
      <Paper
       style={{maxHeight: 200, overflow: 'auto'}}
      >
       
        <Table  >
          <TableHead >
            <TableRow key={0}>
             
              <TableCell style={{width: '20%'}} align="left">Name</TableCell>
              <TableCell style={{width: '20%'}} align="left">Vendor</TableCell>
              <TableCell style={{width: '20%'}}  align="left">Approved Date</TableCell>
              <TableCell style={{width: '20%'}} align="left">Approved By</TableCell>
              <TableCell style={{width: '20%'}} align="left">Expired</TableCell>
              <TableCell align="left"></TableCell>
             
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map(row => (
              
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="left">{row.vendorName}</TableCell>

                <TableCell align="left">
                  {row.approvalDate}
                </TableCell>
                <TableCell align="left">{row.approverName}</TableCell>
                <TableCell align="left">{(row.expired)?"Yes":"No"}</TableCell>
                <TableCell align="left">
                <Button
                            sx={{ minWidth: 34, padding: 0 }}
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                //alert('Edit PIA' + row.id);
                                window.location.href = '/apps/' + row.id
                            }}
                        >
                            <EditIcon />
                        </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      </ThemeProvider>
    </React.Fragment>
  );
}
export default PiaCard;